import { JobFinder } from "../jobFinder";
import { JobOverviewPage } from "../jobOverviewPage";
import { FilterStateManager } from "../filterStateManager";
import { FeaturedData } from "./featuredData";
import { Search } from "../search";
import * as JobTypes from "../../types/jobData";
import { FeaturedFilter } from "./featuredFilter";
import { FeaturedSearch } from "./featuredSearch";
import { flatFeaturedJob } from "../../types/featuredJobList";

type FeaturedJobType = "filter" | "search";

export class FeaturedJobsManager {
  private FeaturedFilter: FeaturedFilter;
  private FeaturedSearch: FeaturedSearch;

  constructor(
    private JobOverviewPage: JobOverviewPage,
    private filterStateManagerInstance: FilterStateManager,
    Search: Search
  ) {
    this.FeaturedFilter = new FeaturedFilter(this.JobOverviewPage, this.filterStateManagerInstance);
    this.FeaturedSearch = new FeaturedSearch(this.JobOverviewPage, Search);
  }

  /**
   * 💡 Purpose of this method
   * - Initializes the FeaturedFilter and loads the featured jobs.
   * - Initializes the FeaturedSearchManager and loads the featured jobs.
   */
  async initialize() {
    console.groupCollapsed("Featured Jobs");
    const FeaturedDataInstance = new FeaturedData();
    FeaturedDataInstance.loadFeaturedJobs();
    const featuredFilterData = FeaturedDataInstance.getFeaturedFilterData();
    const featuredSearchData = FeaturedDataInstance.getFeaturedSearchData();

    this.FeaturedSearch.initialize(featuredSearchData);
    this.FeaturedFilter.initialize(featuredFilterData);
    console.groupEnd();
  }

  getFeaturedJobs(type: FeaturedJobType): JobTypes.jobData[] {
    switch (type) {
      case "filter":
        return this.FeaturedFilter.getFeaturedJobs();
      case "search":
        return this.FeaturedSearch.getFeaturedJobs();
      default:
        return [];
    }
  }

  getCurrentFeaturedJobs(type: FeaturedJobType): JobTypes.jobData[] {
    switch (type) {
      case "filter":
        return this.FeaturedFilter.getCurrentFeaturedJobs();
      case "search":
        return this.FeaturedSearch.getCurrentFeaturedJobs();
      default:
        return [];
    }
  }

  getCurrentFeaturedJobIds(type: FeaturedJobType): number[] {
    switch (type) {
      case "filter":
        return this.FeaturedFilter.getCurrentFeaturedJobIds();
      case "search":
        return this.FeaturedSearch.getCurrentFeaturedJobIds();
      default:
        return [];
    }
  }
}
